import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Title, Text, Button, Group, Stack, ThemeIcon } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

const NotFoundPage: React.FC = () => {
  return (
    <Container size='md' style={{ height: '100vh', display: 'flex', alignItems: 'center' }}>
      <Box style={{ width: '100%', textAlign: 'center' }}>
        <Stack align='center' gap='xl'>
          <Title order={1} size={120} fw={900} c='blue.6'>
            404
          </Title>

          <ThemeIcon size={100} radius={100} color='blue'>
            <IconAlertTriangle size={60} />
          </ThemeIcon>

          <Title order={2} size='h2'>
            Page Not Found
          </Title>

          <Text size='lg' c='dimmed' maw={500} mx='auto'>
            The page you are looking for doesn't exist or has been moved to another URL.
          </Text>

          <Group justify='center' mt='xl'>
            <Button component={Link} to='/' size='md' variant='filled'>
              Back to Home
            </Button>
          </Group>
        </Stack>
      </Box>
    </Container>
  );
};

export default NotFoundPage;
